import { SoundsList } from '../../../../components/sounds-list'

import { IUserAudio } from 'store/types/audio'

import * as Styled from './styled'
import { SoundsListSkeleton } from './skeleton'
import { AudioContentContext } from 'containers/SubSidebar/AudioContent/context'
import { useContext } from 'react'
import { audioThunks } from 'store/features/audio/thunks'
import { dispatch } from 'store'

interface IProps {
  audios: IUserAudio[]
}
export const AudioSearchResult: React.FC<IProps> = ({ audios }) => {
  const { isAudioSearchLoading } = useContext(AudioContentContext)
  const hasNoResult = !audios.length

  return (
    <Styled.AudioSearchResultContainer>
      {hasNoResult && isAudioSearchLoading ? (
        <SoundsListSkeleton itemsCount={10} />
      ) : (
        <SoundsList
          sounds={audios}
          paddingTop={'16px'}
          isLoadingState={isAudioSearchLoading}
          onClickAddButton={() => {
            dispatch(audioThunks.getUsedLibSounds())
          }}
        />
      )}
    </Styled.AudioSearchResultContainer>
  )
}
